import { useLang } from "../../../i18n/LangContext";
import { Button } from "../../ui/button";
import { Card, CardContent } from "../../ui/card";
import { Input } from "../../ui/input";
import { Label } from "../../ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../ui/select";
import { Bilingual, emptyL } from "../Bilingual";

export const blankJourney = { name: { ...emptyL }, description: { ...emptyL }, journey_type: "FAT_LOSS", duration_days: 14 };

export function JourneyForm({ journey, onChange, onSave, onCancel }) {
  const { t } = useLang();
  return (
    <Card data-testid="cms-journey-form" className="bg-[#10121B] border-[#FF3B30]/30">
      <CardContent className="p-5 space-y-4">
        <Bilingual label={t("edu.journeyName")} testId="cms-journey-name" value={journey.name} onChange={(v) => onChange({ ...journey, name: v })} />
        <Bilingual label={t("common.description")} testId="cms-journey-desc" rows={2} value={journey.description} onChange={(v) => onChange({ ...journey, description: v })} />
        <div className="grid sm:grid-cols-2 gap-4">
          <div className="space-y-1.5">
            <Label className="text-slate-300 text-xs">{t("edu.journeyType")}</Label>
            <Select value={journey.journey_type} onValueChange={(v) => onChange({ ...journey, journey_type: v })}>
              <SelectTrigger data-testid="cms-journey-type" className="bg-[#1C202E] border-white/10 text-white h-10"><SelectValue /></SelectTrigger>
              <SelectContent className="bg-[#161923] border-white/10 text-slate-200">
                <SelectItem value="FAT_LOSS">FAT_LOSS</SelectItem>
                <SelectItem value="COACH_QUALIFICATION">COACH_QUALIFICATION</SelectItem>
              </SelectContent>
            </Select>
          </div>
          <div className="space-y-1.5">
            <Label className="text-slate-300 text-xs">{t("edu.durationDays")}</Label>
            <Input data-testid="cms-journey-duration" type="number" min={1} value={journey.duration_days}
              onChange={(e) => onChange({ ...journey, duration_days: e.target.value })} className="bg-[#1C202E] border-white/10 text-white h-10" />
          </div>
        </div>
        <div className="flex justify-end gap-2">
          <Button variant="ghost" onClick={onCancel} className="text-slate-300 h-10">{t("common.cancel")}</Button>
          <Button data-testid="cms-journey-save-btn" onClick={onSave} className="bg-[#FF3B30] hover:bg-[#E02E24] text-white font-semibold h-10">{t("common.save")}</Button>
        </div>
      </CardContent>
    </Card>
  );
}
